import { useState } from "react";
import { Card, CardBody, Col, Toast, ToastBody } from "reactstrap";
import { DoYouIntendToContinue, ImNotSure, RemoveMyAccount, UniqueToasts, YourAccountWillBePermanentlyDeleted } from "../../../../Constant";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { UNIQUE_TOAST } from "../../../../Data/Bonus Ui/Toasts";
import { dynamicImage } from "../../../../Service/DynamicImage";
import { Btn, H6, Image, P } from "../../../../AbstractElements";

const UniqueToast = () => {
  const [open, setOpen] = useState(true);
  return (
    <Col md="6">
      <Card className="height-equal">
        <CommonCardHeader title={UniqueToasts} span={UNIQUE_TOAST} />
        <CardBody className="toast-rtl">
          <Toast fade isOpen={open}>
            <div className="toast-header toast-img">
              <Image className="rounded me-2" src={dynamicImage("avtar/profile.png")} alt="profile" />
              <strong className="me-auto">Boho theme</strong>
              <Btn className="btn-close p-0" onClick={() => setOpen(false)}></Btn>
            </div>
            <ToastBody className="toast-dark">
              <H6 className="mb-2">{YourAccountWillBePermanentlyDeleted}</H6>
              <P className="mb-0">{DoYouIntendToContinue}</P>
              <div className="mt-2 pt-2 border-top d-flex gap-2">
                <Btn color="dark" size="sm">{ImNotSure}</Btn>
                <Btn color="danger" size="sm" onClick={() => setOpen(false)}>{RemoveMyAccount}</Btn>
              </div>
            </ToastBody>
          </Toast>
        </CardBody>
      </Card>
    </Col>
  );
};

export default UniqueToast;
